import {
  Component,
  Directive,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';

@Directive({
  selector: 'card-content',
  host: { class: 'card__content' },
})
export class CardContentComponent {}

@Component({
  selector: 'card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.style.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'card',
  },
})
export class CardComponent extends BaseComponent {
  @Input() interactive: boolean = false;

  constructor() {
    super();
  }
}

@Component({
  selector: 'card-header',
  templateUrl: './card-header.html',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'card__header' },
})
export class CardHeaderComponent {}
